<!--我的销售额-->
<template>
  <div class="box">
    <div class="weiyuanhui-box">
      <div class="tabs-box flex-start">
        <div :class="active == 0 ? 'tab-li-active' : 'tab-li'" @click="active=0">本月新增</div>
        <div :class="active == 1 ? 'tab-li-active' : 'tab-li'" @click="active=1">累计数量</div>
      </div>

      <!--      <van-tabs class="earn" v-model="active" type="card" @change="onTabChange">-->
      <!--        <van-tab title="本月新增"></van-tab>-->
      <!--        <van-tab title="累计数量"></van-tab>-->
      <!--      </van-tabs>-->

      <div class="earn-all">
        <div class="earn-all-top">
          <div class="earn-top-left">
            <div class="top-text">考级中心数</div>
            <div class="earn-all-money">{{ active == 1 ? row.total_examecenter : row.month_examecenter }}</div>
          </div>
          <div class="earn-top-left">
            <div class="top-text">考级点数</div>
            <div class="earn-all-money">{{ active == 1 ? row.total_kaoji : row.month_kaoji }}</div>
          </div>
          <div class="earn-top-left">
            <div class="top-text">当前考级人数</div>
            <div class="earn-all-money">{{ active == 1 ? row.total_kaoji_member : row.month_kaoji_member }}</div>
          </div>
        </div>
        <div class="earn-all-top">
          <div class="earn-top-left">
            <div class="top-text">赛事场数</div>
            <div class="earn-all-money">{{ active == 1 ? row.total_sai : row.month_sai }}</div>
          </div>
          <div class="earn-top-left">
          </div>
          <div class="earn-top-left">
            <div class="top-text">赛事人数</div>
            <div class="earn-all-money">{{ active == 1 ? row.total_sai_member : row.month_sai_member }}</div>
          </div>
        </div>
        <div class="earn-all-top">
          <div class="earn-top-left">
            <div class="top-text">培训数</div>
            <div class="earn-all-money">{{ active == 1 ? row.total_huiyi : row.month_huiyi }}</div>
          </div>
          <div class="earn-top-left">
          </div>
          <div class="earn-top-left">
            <div class="top-text">培训人数</div>
            <div class="earn-all-money">{{ active == 1 ? row.total_huiyi_member : row.month_huiyi_member }}</div>
          </div>
        </div>
        <div class="earn-all-top">
          <div class="earn-top-left">
            <div class="top-text">俱乐部数量</div>
            <div class="earn-all-money">{{ active == 1 ? row.total_club : row.month_club }}</div>
          </div>
          <div class="earn-top-left">
          </div>
          <div class="earn-top-left">
            <div class="top-text">注册运动员数</div>
            <div class="earn-all-money">{{ active == 1 ? row.total_yundongyuan : row.month_yundongyuan }}</div>
          </div>
        </div>
      </div>

      <!--      <div class="earn-all" v-if="row.city_list.length > 0">-->
      <!--        <div class="earn-all-bottom" v-for="(item, index) in row.city_list">-->
      <!--          <div class="earn-top-left">-->
      <!--            <div class="top-text">{{ item.city }}</div>-->
      <!--            <div class="earn-all-money">-->
      <!--              裁判员人数:{{ item.caipan_count }},教练员人数:{{ item.jiaolian_count }},运动员人数:{{ item.caipan_count }}-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->

      <!--      </div>-->

      <div class="earn-city-box" v-if="row.city_list.length > 0">
        <div class="earn-city-li" v-for="(item, index) in row.city_list">
          <div class="city-li-box">
            <div class="city-title">{{ item.city }}</div>
            <div class="city-member flex-between">
              <div class="city-member-li">
                <div class="city-member-num">{{ item.caipan_count }}</div>
                <div class="city-member-title">裁判员</div>
              </div>
              <div class="city-member-li">
                <div class="city-member-num">{{ item.jiaolian_count }}</div>
                <div class="city-member-title">教练员</div>
              </div>
              <div class="city-member-li">
                <div class="city-member-num">{{ item.caipan_count }}</div>
                <div class="city-member-title">运动员</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style src="../../../assets/style/weiyuanhui.css" scoped></style>
<style scoped>
.box {
  background: #f8f8f8;
  min-height: 100%;
}

.earn-city-box {
  margin: .3rem;
  display: flex;
  flex-wrap: wrap;
}

.earn-city-li {
  margin-bottom: .3rem;
  background: #FFFFFF;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  width: 3.3rem;
  max-width: 3.3rem;
  /*padding: .3rem .2rem;*/
  text-align: center;
}

.earn-city-li:nth-child(odd) {
  margin-right: .3rem;
}

.city-li-box {
  padding: .3rem .2rem;
}

.earn-city-li .city-title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  position: relative;
  margin-bottom: .3rem;
  display: inline-block;
}

.earn-city-li .city-title:after {
  content: '';
  position: absolute;
  left: 4px;
  bottom: 1px;
  right: 0;
  border-radius: 1px;
  width: 38px;
  height: 3px;
  background: #FFCC00;
}

.city-member-num {
  font-size: 16px;
  font-family: DINCond-Black, DINCond;
  font-weight: 900;
  color: #333333;
}

.city-member-title {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.weiyuanhui-box {
  background: url('../../../assets/images/weiyuanhui/icon-detail-bg.png') no-repeat;
  background-size: 7.5rem 4.8rem;
}

.tabs-box {
  padding: 2rem .3rem .2rem;
}

.tab-li {
  margin-right: .3rem;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}

.tab-li-active {
  margin-right: .3rem;
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  border-bottom: 2px solid #333333;
}

#earn-table {
  background: #fff;
}

.earn {
  padding-top: .2rem !important;
}

.earn .van-tabs__nav--card {
  width: 3.3rem;
  margin: 0 auto;
}

.van-tabs--card {
  margin: 0 auto;
  width: 4rem;
  padding-top: 0;
}

.earn-table {
  height: 3rem;
  background: #fff;
}

.earn-all {
  margin: .3rem .3rem 0;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  background: #fff;
}

.earn-all-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #EEE;
  padding: 0.3rem;
}

.earn-all-top:last-child {
  border-bottom: none;
}

.earn-all-bottom {
  display: flex;
  flex-wrap: wrap;
  /*justify-content: center;*/
  /*align-items: center;*/
  border-bottom: 1px solid #EFEFEF;
  padding: 0.3rem;
}

.earn-top-left {
  /*border-right: 1px solid #EFEFEF;*/
}


.earn-top-left,
.earn-top-right {
  flex: 1;
  margin-left: 0.3rem;
}

.earn-top-right {
  margin-left: 0.6rem;
}

.earn-top-left .top-text {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.earn-all-money {
  margin-top: 0.1rem;
  font-size: 26px;
  font-family: DINCond-Black, DINCond;
  font-weight: 900;
  color: #333333;
}

.earn-all-money span {
  font-size: 12px;
}

.earn-near {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.earn-near-img {
  width: 0.24rem;
  height: 0.24rem;
  margin-left: 0.05rem;
}

.earn-all-bottom .earn-top-cennter:nth-child(3) {
  border-right: none;
}

.earn-ye-img {
  width: 14px;
  height: 14px;
  margin-left: 0.05rem;
}

.earn-list {
  color: #181818;
  margin-top: 0.1rem;
  background: #fff;
}

</style>

<script>
import Vue from 'vue';
import {
  Tab,
  Tabs,
  Cell,
  CellGroup,
  Toast
} from 'vant';

Vue.use(Tab).use(Tabs).use(Cell).use(CellGroup).use(Toast)
export default {
  name: 'WeiyuanhuiDetail',
  components: {},
  data: function () {
    return {
      active: 0,
      total_income: 0,
      total_income_30: 0,
      current_month_income: 0,
      un_cash_balance: 0,
      cash_balance: 0,
      current_month_expect_profit: 0,
      total_expect_profit: 0,
      orderChartData: [],
      incomeChartData: [],
      profitExpectCartData: [],
      row: {}
    }
  },
  filter: {},
  mounted() {
    document.title = "数据详情"
    this.getWeiyuanhuiDetail()
  },
  destroyed() {
  },
  methods: {
    getWeiyuanhuiDetail() {
      let that = this;
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      that.$api.get('/wyhadminapi/weiyuanhui/wyhIndexData', {}, (res) => {
        that.total_income = res.data.total_income;
        that.current_month_income = res.data.current_month_income;
        that.un_cash_balance = res.data.un_cash_balance;
        that.cash_balance = res.data.cash_balance;
        that.orderChartData = res.data.orderChartData;
        that.incomeChartData = res.data.incomeChartData;
        that.profitExpectCartData = res.data.profitExpectCartData;
        that.current_month_expect_profit = res.data.current_month_expect_profit;
        that.total_expect_profit = res.data.total_expect_profit;

        that.row = res.data
        // that.toChart(that.profitExpectCartData)
        Toast.clear();
      })
    },

    // BusinessOrderList
    toBusinessOrderList() {
      this.$router.push({name: 'BusinessOrderCashList'})
    },

    toBank() {
      let that = this;
      that.$router.push({
        name: 'SiteSettingBank'
      })
    },

    onTabChange(data) {
      console.log('onTabChange', data)
      let that = this;
      // if (data == 0) {
      //     that.toChart(that.profitExpectCartData);
      // } else {
      //     that.toChart(that.orderChartData);
      // }
    },

    toChart(chartdata) {
      let ChartDataX = []
      let ChartDataY = []
      chartdata.map((ChartData) => {
        ChartDataX.push(ChartData.date)
        ChartDataY.push(ChartData.count)
      })

      // 引入 ECharts 主模块
      var echarts = require('echarts/lib/echarts');
      // 引入柱状图
      require('echarts/lib/chart/bar');
      // 引入提示框和标题组件
      require('echarts/lib/component/tooltip');
      require('echarts/lib/component/title');

      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('earn-table'));
      // 绘制图表
      myChart.setOption({
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '4%',
          top: '8%',
          right: '4%',
          bottom: '2%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ChartDataX,
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: '50%',
            data: ChartDataY
          }
        ]
      });
    },

    tipuncash() {
      Toast('客户已签收，销售额未到账的金额')
    },

    tipcash() {
      Toast('已汇到您提现账户的金额')
    }
  }
}
</script>



// WEBPACK FOOTER //
// WeiyuanhuiDetail.vue?469935e3